export const ARTICLE_COMPANY_ID = 656

export const ARTICLE_TYPES = Object.freeze({
    NEWS: 'News',
    KNOWLEDGE: 'Knowledge',
    INCIDENT: 'Incident',
})

export const ARTICLE_CATEGORIES = Object.freeze({
    COMMUNICATIONS: 'Communications',
    GENERAL: 'General',
    KUBEPORT: 'KubePort',
    USD_ANNOUNCEMENTS: 'USD Announcements',
    SECURITY: 'Security',
    INCIDENT: 'Incident',
    SECURITY_VULNERABILITIES: 'Security Vulnerabilities',
})

export const ARTICLE_SUBCATEGORIES = Object.freeze({
    GENERAL: 'General',
    NEWS: 'News',
    RELEASE_MANAGEMENT: 'Release Management',
    THREAT_NEWS: 'Threat News',
    SECURITY_ADVISORY_NEWS: 'Security Advisory News',
    SECURITY_ADVISORY_NOTIFICATION: 'Security Advisory Notification',
    P1: 'P1',
    P2: 'P2',
    P3: 'P3',
})

export const SECURITY_VULNERABILITIES =
    ARTICLE_CATEGORIES.SECURITY_VULNERABILITIES

export const SECURITY_ADVISORY_NEWS =
    ARTICLE_SUBCATEGORIES.SECURITY_ADVISORY_NEWS

export const SECURITY_ADVISORY_NOTIFICATION =
    ARTICLE_SUBCATEGORIES.SECURITY_ADVISORY_NOTIFICATION

export const SECURITY_ADVISORY_TEMPLATE_URL =
    '/api/news/templates/security_advisory_news_template'
export const CSA_NOTIFICATION_TEMPLATE_URL =
    '/api/news/templates/csa_notification'

export const ARTICLE_ATTACHMENT_URL = articleId =>
    `/api/news/articles/${articleId}/attachment`

export const ARTICLE_API_URL = '/api/news/articles'

export const ARTICLE_IMAGE_MAX_SIZE = 16777215

export const ARTICLE_ATTACHMENT_ALLOWED_TYPES = Object.freeze([
    '.pdf',
    '.xls',
    '.xlsx',
])

export const AUTHOR_COMPANY = 'Cegeka'

export const PRE_POPULATE_EMAIL_MAPPING = Object.freeze({
    [`${SECURITY_VULNERABILITIES}|${SECURITY_ADVISORY_NEWS}`]: Object.freeze({
        to: Object.freeze(['emergency.sab@cegeka.com']),
        cc: Object.freeze(['securityofficer@cegeka.com']),
        bcc: Object.freeze(['Security.AdvisoryBCC@cegeka.com']),
    }),

    [`${SECURITY_VULNERABILITIES}|${SECURITY_ADVISORY_NOTIFICATION}`]:
        Object.freeze({
            to: Object.freeze(['emergency.sab@cegeka.com']),
            cc: Object.freeze(['securityofficer@cegeka.com']),
            bcc: Object.freeze(['Security.AdvisoryBCC@cegeka.com']),
        }),
})

export const SUBCATEGORY_MAP = Object.freeze({
    'Knowledge-General': Object.freeze([ARTICLE_SUBCATEGORIES.GENERAL]),

    'News-Communications': Object.freeze([
        ARTICLE_SUBCATEGORIES.GENERAL,
        ARTICLE_SUBCATEGORIES.NEWS,
        ARTICLE_SUBCATEGORIES.RELEASE_MANAGEMENT,
    ]),

    'News-General': Object.freeze([
        ARTICLE_SUBCATEGORIES.GENERAL,
        ARTICLE_SUBCATEGORIES.RELEASE_MANAGEMENT,
    ]),

    'News-KubePort': Object.freeze([
        ARTICLE_SUBCATEGORIES.GENERAL,
        ARTICLE_SUBCATEGORIES.NEWS,
    ]),

    'News-Security': Object.freeze([ARTICLE_SUBCATEGORIES.THREAT_NEWS]),

    'News-Security Vulnerabilities': Object.freeze([
        ARTICLE_SUBCATEGORIES.SECURITY_ADVISORY_NEWS,
        ARTICLE_SUBCATEGORIES.SECURITY_ADVISORY_NOTIFICATION,
    ]),

    'News-USD Announcements': Object.freeze([
        ARTICLE_SUBCATEGORIES.GENERAL,
        ARTICLE_SUBCATEGORIES.RELEASE_MANAGEMENT,
    ]),

    'Incident-General': Object.freeze([
        ARTICLE_SUBCATEGORIES.P1,
        ARTICLE_SUBCATEGORIES.P2,
        ARTICLE_SUBCATEGORIES.P3,
    ]),

    'Incident-Incident': Object.freeze([
        ARTICLE_SUBCATEGORIES.P1,
        ARTICLE_SUBCATEGORIES.P2,
        ARTICLE_SUBCATEGORIES.P3,
    ]),
})
